import { render, staticRenderFns } from "./ShippingBindingRecord.vue?vue&type=template&id=686b2238&scoped=true"
import script from "./ShippingBindingRecord.vue?vue&type=script&lang=js"
export * from "./ShippingBindingRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686b2238",
  null
  
)

export default component.exports